import type { GemXqlResultSelectFragment } from '~/core/gemxql/graphql';

import { IRMetricKey } from '~/presentation/reports/common/type';

export enum EReportSource {
  CAMPAIGN = 'campaign',
  PAGE = 'page',
}

export enum EReportParamKeys {
  FROM = 'from',
  PATH = 'path',
  CAMPAIGN_ID = 'campaign_id',
  CAMPAIGN_TYPE = 'campaign_type',
  CAMPAIGN_GROUP_ID = 'campaign_group_id',
  SINCE = 'since',
  UNTIL = 'until',
  ALIAS = 'alias',
  VERSION_ID = 'version_id',
  DATE_TITLE = 'date_title',
  IS_CURRENT_VERSION = 'is_current_version',
  MODE = 'mode',
  ORDER_VIEW_SCOPE = 'order_view_scope',
  CURRENCY = 'currency',
}

export enum EReportPresetKey {
  ORDER = IRMetricKey.ORDERS,
  SESSION = IRMetricKey.SESSION,
  PAGEVIEW = IRMetricKey.PAGE_VIEWS,
  BR = IRMetricKey.BOUNCE_RATE,
  VISITOR = IRMetricKey.VISITORS,
  RPV = IRMetricKey.RPV,
  REVENUE = IRMetricKey.REVENUE,
  AOV = IRMetricKey.AOV,
  CART_ADDITION = IRMetricKey.CART_ADDITION,
  ADD_TO_CART_RATE = IRMetricKey.ADD_TO_CART_RATE,
  REACHED_CHECKOUT = IRMetricKey.REACHED_CHECKOUT,
  COMPLETED_CHECKOUT = IRMetricKey.COMPLETE_CHECKOUT,
  CTR = IRMetricKey.CTR,
  CONVERSION_RATE = IRMetricKey.CONVERSION_RATE,
  ADDED_TO_CART = IRMetricKey.ADDED_TO_CART,
  AVG = IRMetricKey.AVG_TIME_ON_PAGE,
  SESSION_BY_DEVICE_TYPE = IRMetricKey.SESSION_BY_DEVICE_TYPE,
  VISITOR_BY_TYPE = IRMetricKey.VISITOR_BY_TYPE,
  SESSION_BY_TRAFFIC_SOURCE = IRMetricKey.SESSION_BY_TRAFFIC_SOURCE,
}
export type IReportType = GemXqlResultSelectFragment;
